module.exports = __webpack_public_path__ + "img/3beb4e62f0072e7eccb206c3c549331b.jpg";